export default {
    apiUrl: '/api/v1/',
    isDevelopmentMode: true,
};
